import React from "react";

import Common from "./../../Common";

class PasswordUpdate extends Common {
  constructor(props) {
    super(props);
    var has_local_data = this.getFromStorage("encdata") ? 1 : 0;
    var localdata = has_local_data
      ? this.decrypt(this.getFromStorage("encdata"), 0)
      : "";
    console.log(localdata);
    this.state = {
      redirect: false,
      apiUrl: this.decryptconfigdata("apiUrl"),
      fields: {},
      formData: {},
      localdata: localdata,
      message: "",
      errors: {},
    };
    this.schema = {
      title: "Password Reset",
      type: "object",
      required: [],
      properties: {},
      "ui:formButtons": { submit: "Envoyer" },
    };
    this.UiSchema = {};
    this.submitUser = this.submitUser.bind(this);
  }

  validate() {
    let formData = this.state.formData;
    console.log("dataaaaaa", this.state.formData.password);
    let errors = {};
    let formIsValid = true;
    if (formData["old_password"]) {
      formIsValid = false;
      var pattern =
        /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{8,30}$/;
      if (!pattern.test(formData.old_password)) {
        errors["old_password"] =
          "Make it strong! at least 1 special character,1 number & 1 Uppercase letter";
      }
    } else {
      errors["old_password"] = "This field is required.";
    }

    if (formData["new_password"]) {
      formIsValid = false;
      var pattern =
        /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{8,30}$/;
      if (!pattern.test(formData.new_password)) {
        errors["new_password"] =
          "Make it strong! at least 1 special character,1 number & 1 Uppercase letter";
      }
    } else {
      errors["new_password"] = "This field is required.";
    }

    if (formData["cnf_password"]) {
      var pattern =
        /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{8,30}$/;
      if (!pattern.test(formData.cnf_password)) {
        errors["cnf_password"] =
          "Make it strong! at least 1 special character,1 number & 1 Uppercase letter";
      }
      if (!formData["cnf_password"]) {
        errors["cnf_password"] = "This field is required.";
      }
    } else {
      errors["cnf_password"] = "This field is required.";
    }
    if (formData["new_password"] !== formData["cnf_password"]) {
      errors["cnf_password"] = "Passwords don't match";
    }

    this.setState({ errors: errors });
    console.log("errrrrr", this.state.errors);
    return formIsValid;
  }
  changeFormData(event) {
    var formData = this.state.formData;
    if (event.target.name) {
      formData[event.target.name] = event.target.value;
      this.setState({
        formData: formData,
      });
    }
  }

  submitUser(event) {
    event.preventDefault();
    if (this.validate()) {
      return false;
    }

    this.state.fields["formData"] = this.state.formData;
    this.state.fields["token"] = this.state.localdata.response;
    this.state.fields["app_token"] = this.state.localdata.data.app_token;
    this.state.fields["product_key"] = this.state.localdata.data.product_key;
    this.state.fields["name"] = this.state.localdata.data.name;
    this.state.fields["email"] = this.state.localdata.data.email;

    console.log("formdata", this.state.formData);
    document.getElementById("add_user_btn").disabled = true;
    fetch(this.state.apiUrl + "User/resetpassword", {
      method: "POST",
      dataType: "json",
      body: JSON.stringify(this.state.fields),
    })
      .then((response) => response.json())
      .then((result) => {
        result = this.decrypt(result, 1);
        if (result.code === 200) {
          document.getElementById("add_user_btn").disabled = true;

          var conf = window.confirm(
            "Password Successfully Changed.. Wish You Good Luck.."
          );
          if (conf) {
            window.location.href = "/manage-users";
          }
        } else {
          this.setState({
            error_message: result.msg,
            //formData: data.formData
          });
          document.getElementById("add_user_btn").disabled = false;
        }
      });
    return false;
  }

  render() {
    return (
      <div class="p-24-lr">
        <div>
          {this.state.error_message ? (
            <div className="alert alert-danger">{this.state.error_message}</div>
          ) : (
            ""
          )}
          <form>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
              <div class="mb-3">
                <label class="form-label">Old Password*</label>
                <input
                  type="password"
                  id="name"
                  name="old_password"
                  value={this.state.formData["old_password"]}
                  onChange={(event) => this.changeFormData(event)}
                  class="form-control"
                />
                <span class="error">{this.state.errors["old_password"]}</span>
              </div>

              <div class="mb-3">
                <label class="form-label">New Password*</label>
                <input
                  type="password"
                  id="name"
                  name="new_password"
                  value={this.state.formData["new_password"]}
                  onChange={(event) => this.changeFormData(event)}
                  class="form-control"
                />
                <span class="error">{this.state.errors["new_password"]}</span>
              </div>

              <div class="mb-3">
                <label class="form-label">Confirm Password*</label>
                <input
                  type="password"
                  id="name"
                  name="cnf_password"
                  value={this.state.formData["cnf_password"]}
                  onChange={(event) => this.changeFormData(event)}
                  class="form-control"
                />
                <span class="error">{this.state.errors["cnf_password"]}</span>
              </div>
              <div class="d-flex justify-content-end">
                <button
                  type="submit"
                  id="add_user_btn"
                  class="muBtn _blue _minW"
                  onClick={(e) => this.submitUser(e)}
                >
                  Update Password
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
export default PasswordUpdate;
